const OVERLAY_SHOW_DELAY_MS = 180;
const OVERLAY_FADE_MS = 280;
const PROGRESS_COMPLETE_HOLD_MS = 150;

const overlayStates = new WeakMap();

export function getOverlayElement() {
    return document.getElementById('overlay');
}

function getStableOverlayElement(excludedContainerId) {
    const first = document.getElementById('overlay');
    if (!first) {
        return null;
    }
    const excluded = document.getElementById(excludedContainerId);
    if (!excluded || !excluded.contains(first)) {
        return first;
    }
    const overlays = document.querySelectorAll('#overlay');
    for (let i = 0; i < overlays.length; i++) {
        if (!excluded.contains(overlays[i])) {
            return overlays[i];
        }
    }
    return first;
}

export function getManagerOverlayElement() {
    return getStableOverlayElement('mgr_index_paging');
}

export function getMemberOverlayElement() {
    return getStableOverlayElement('index_paging');
}

export function setOverlayLabel(overlay, text) {
    if (!overlay) return;
    const label = overlay.querySelector('.spinner-label');
    if (label) label.textContent = text;
}

export function setOverlayProgress(overlay, percent) {
    if (!overlay) return;
    overlay.classList.add('overlay-progress');
    const value = overlay.querySelector('.spinner-percent');
    if (value) value.textContent = Math.max(0, Math.min(100, Math.floor(percent))) + '%';
}

export function clearOverlayProgress(overlay) {
    if (!overlay) return;
    overlay.classList.remove('overlay-progress');
}

function getOverlayState(overlay) {
    let state = overlayStates.get(overlay);
    if (!state) {
        state = {
            showTimer: null,
            holdTimer: null,
            displayTimer: null,
            visible: false,
            minVisibleUntil: 0,
            hideAfterMin: false,
        };
        overlayStates.set(overlay, state);
    }
    return state;
}

function clearOverlayTimers(state) {
    clearTimeout(state.showTimer);
    clearTimeout(state.holdTimer);
    clearTimeout(state.displayTimer);
    state.showTimer = null;
    state.holdTimer = null;
    state.displayTimer = null;
}

function setFillClass(overlay, className) {
    overlay.classList.add('overlay-snap');
    void overlay.offsetWidth;
    overlay.classList.remove('overlay-visible', 'overlay-complete', 'overlay-snap');
    if (className) {
        overlay.classList.add(className);
    }
}

function revealOverlay(overlay, state) {
    state.visible = true;
    overlay.style.display = 'flex';
    setFillClass(overlay, 'overlay-visible');
}

function forceHideOverlayElement(overlay) {
    overlay.classList.remove('overlay-visible', 'overlay-complete', 'overlay-snap');
    clearOverlayProgress(overlay);
    overlay.style.display = 'none';
}

export function showOverlay(overlay, opts) {
    if (!overlay) return;
    const state = getOverlayState(overlay);
    state.hideAfterMin = false;
    clearOverlayTimers(state);
    if (opts && opts.minVisibleMs > 0) {
        state.minVisibleUntil = Date.now() + opts.minVisibleMs;
    }
    if (opts && opts.immediate) {
        revealOverlay(overlay, state);
        return;
    }
    if (!state.visible) {
        forceHideOverlayElement(overlay);
    }
    state.showTimer = setTimeout(function () {
        state.showTimer = null;
        revealOverlay(overlay, state);
    }, OVERLAY_SHOW_DELAY_MS);
}

export function hideOverlay(overlay, opts) {
    if (!overlay) return;
    const state = getOverlayState(overlay);
    const immediate = Boolean(opts && opts.immediate);
    if (!immediate && state.hideAfterMin) {
        return;
    }
    if (!immediate && state.minVisibleUntil > Date.now()) {
        const wait = state.minVisibleUntil - Date.now();
        state.minVisibleUntil = 0;
        state.hideAfterMin = true;
        clearOverlayTimers(state);
        state.holdTimer = setTimeout(function () {
            state.holdTimer = null;
            state.hideAfterMin = false;
            hideOverlay(overlay, opts);
        }, wait);
        return;
    }
    state.minVisibleUntil = 0;
    state.hideAfterMin = false;
    clearOverlayTimers(state);
    if (immediate || !state.visible) {
        state.visible = false;
        forceHideOverlayElement(overlay);
        return;
    }
    state.visible = false;
    setFillClass(overlay, 'overlay-complete');
    state.holdTimer = setTimeout(function () {
        state.holdTimer = null;
        overlay.classList.remove('overlay-visible');
        overlay.classList.remove('overlay-complete');
        state.displayTimer = setTimeout(function () {
            state.displayTimer = null;
            clearOverlayProgress(overlay);
            overlay.style.display = 'none';
        }, OVERLAY_FADE_MS);
    }, PROGRESS_COMPLETE_HOLD_MS);
}
